$(function () {
    $('.js-release-images').each(function() {
        const $item = $(this);

        const $stateValue = $(this).find('.js-release-images-state');
        const $pathValue = $(this).find('.js-release-images-path');
        const $typeValue = $(this).find('.js-release-images-type');
        const $thumbnailValue = $(this).find('.js-release-images-thumbnail');
        const $thumbnailTag = $(this).find('.js-release-images-thumbnail-preview');
        const $error = $(this).find('.js-release-images-path');

        // 新規リリース画像アップロードボタン
        const $jsUploadReleaseImage = $(this).find('.js-upload-release-image');

        // リリース画像削除ボタン
        const $jsDeleteReleaseImage = $(this).find('.js-delete-release-image');

        // 新規アップロードボタンと削除ボタンの表示切り替え
        const changeAction = (uploaded) => {
            if (uploaded) {
                $jsUploadReleaseImage.hide();
                $jsDeleteReleaseImage.show();
            } else {
                $jsUploadReleaseImage.show();
                $jsDeleteReleaseImage.hide();
            }
        }

        // 初回表示時に新規アップロードボタンと削除ボタンの表示切り替えを行う
        if ($thumbnailTag.find('img').length) {
            changeAction(true);
        } else {
            changeAction(false);
        }

        $item.find('.js-release-images-upload').change(function(e) {

            const $file = $(e.target);

            const action = $(e.target).data('action');

            // 表示中のサムネイルを非表示
            $thumbnailTag.find('img').hide();

            // エラー状態初期化
            $file.removeClass('is-invalid');
            $error.text('');

            // Loading表示
            const $loading = $('<div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>');
            $thumbnailTag.append($loading);

            let formData = new FormData();
            let file = $(this)[0].files[0];
            formData.append('image', file, file.name);
            $.ajax({
                url: action,
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                type: 'POST',
                contentType: false,
                processData: false,
                cache: false,
                data: formData,
                success: function(data) {

                    $stateValue.val('create');
                    $pathValue.val(data.response.path);
                    $typeValue.val(data.response.type);
                    $thumbnailValue.val(data.response.thumbnail);

                    // 表示中のサムネイルを削除
                    $thumbnailTag.find('img').remove();

                    // 新しいimgタグを作成表示
                    $thumbnailTag.append(`<img src="${data.response.link}">`);

                    changeAction(true);
                },
                error: function(data) {
                    $file.addClass('is-invalid');
                    if (data.responseJSON) {
                        $error.text(Object.values(data.responseJSON.errors).join('\n'));
                    } else {
                        // webサーバーでpost maxサイズを超えてエラーになる場合status textが表示される
                        $error.text(data.statusText);
                    }

                    // エラーの場合は非表示にした画像を表示する
                    $thumbnailTag.find('img').show();
                },
                complete: function() {
                    // ローディング削除
                    $loading.remove();
                }
            });
        });

        // リリース画像削除ボタン押下時の処理
        $item.find('.js-delete-release-image').click(function(e) {
            $stateValue.val('delete');
            $thumbnailTag.empty();
            changeAction(false);
        });
    });
})

//リリース一覧のプルダウン変更時の処理
$(function () {

    $('.js-change-companies-menu').on('change', (e) => {

        const value =  e.target.value;
        const action = $("option:selected", e.target).data('action');
        const confirmMessage = $("option:selected", e.target).data('confirm');

        // 再選択を行う場合に備えて該当項目の選択状態を解除
        e.target.value = '';

        if (confirmMessage && !confirm(confirmMessage)) {
            return false;
        }

        switch (value) {

            case 'preview':
            case 'edit': {
                location.href = action;
                break;
            }
            case 'archive': {
                let form = document.createElement('form');
                form.action = action;
                form.method = 'POST';

                let token = document.createElement("input");
                token.setAttribute("type","hidden");
                token.setAttribute("name","_token");
                token.setAttribute("value",$('meta[name="csrf-token"]').attr('content'));
                form.appendChild(token);

                document.body.appendChild(form);
                form.submit();
                break;
            }
        }
    })

})
